import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.75 4.4167L12.083 6.75L5.667 13.1667L2.75 13.75L3.333 10.8333L9.75 4.4167ZM4.408 11.4085L4.237 12.2628L5.091 12.0919L10.433 6.75L9.75 6.0666L4.408 11.4085Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.838 5.9958L10.504 3.6625L11.329 2.8375L13.663 5.1709L12.838 5.9958Z",
		fill: "currentColor"
	})]
});
export default SvgPencil;
